

var _angular = require('angular');

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-device-info/dist/index');

var _auth = require('xo-models/src/auth');

var _index2 = require('xo-models/src/checkout/index');

require('xo-title/dist/directive');

require('xo-ui-components/src/message/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _fi = require('xo-models/src/fi');

var _user = require('xo-models/src/user');

var _directive = require('../directive');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoBmlTermsAndConditionsPage', function () {
    var linkFn = function linkFn(scope, element, attrs) {
        var $agreeButton = $('#bmlAgreeToTerms');

        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent',
            eventer = window[eventMethod],
            data,
            messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

        // Browsers that support postMessage
        if (window.postMessage) {
            /**
             * Event to listen for post messages sent from PayPal popup window.
             * Data from PayPal will contains return url and the localised content.
             */
            eventer(messageEvent, function (event) {
                data = angular.fromJson(event.data);
                if (data.action === 'scroll') {

                    if (data.toEnd && !scope.isMobile) {
                        scope.scrollComplete();
                    }
                } else if (data.action === 'setHeight' && scope.isMobile) {
                    $('.bmlTermsBody iframe').css('height', data.height + 20 + 'px');
                }
            }, false);
        }

        $agreeButton.click(function (event) {
            event.preventDefault();
            scope.handleAgreeToTermsClick();
        });
    };

    return {
        template: _template2['default'],
        link: linkFn,
        controller: ['$scope', function ($scope) {
            if ($scope.$parent && $scope.$parent.bml) {
                $scope.bml = $scope.$parent.bml;
                $scope.bmlApply = $scope.$parent.bmlApply;
                $scope.bmlComplete = $scope.$parent.bmlComplete;
            }

            (0, _squid.$populate)($scope, {
                auth: _auth.$AuthModel.instance(),
                payee: _index2.$CheckoutPayeeModel.instance(_angular.$rootScope.token),
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                checkoutCart: _index2.$CheckoutCartModel.instance(_angular.$rootScope.token),
                checkoutSession: _index2.$CheckoutSessionModel.instance(_angular.$rootScope.token),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                $scope.patchPhoneModel = new _user.$PatchPhoneModel();
                $scope.patchPhoneModel.token = $scope.token;

                if ($scope.$parent && $scope.$parent.bml) {
                    var bmlData = {
                        reviewUrl: $scope.$parent.reviewUrl,
                        bml: $scope.bml,
                        bmlApply: $scope.bmlApply,
                        bmlComplete: $scope.bmlComplete,
                        checkoutSession: $scope.checkoutSession,
                        auth: $scope.auth,
                        purchase: $scope.checkoutCart.purchase,
                        patchPhone: $scope.patchPhoneModel,
                        billingAddresses: $scope.billingAddresses,
                        merchant: $scope.checkoutAppData.merchant,
                        merchantId: $scope.payee.merchant.id
                    };

                    $scope.bmlStateHandler = new _directive.$BMLStateHandler(bmlData);
                }
            });

            $scope.init = function () {
                $scope.token = _angular.$rootScope.token;
                $('.paypalHeaderWrapper').addClass('paypalCreditTnc');
                $('.paypalHeader').removeClass('span14');
                $('.paypalHeader').addClass('span24');
                $('.paypalHeader').addClass('headerBar');
                $('.footerWrapper').addClass('hide');
                $scope.isMobile = _index.$DeviceInfo.isMobile();
                $scope.isMiniBrowser = _angular.$rootScope.miniBrowser;
                $scope.bmlFlags = {
                    bmlFooterShow: true,
                    full: true,
                    xoFooter: true,
                    enableFooter: true,
                    showConfirmationModal: false,
                    showModalBackdrop: true
                };

                if (window.scrollTo) {
                    window.scrollTo(0, 0);
                }
                _logger.$logger.info('TERMSNCONDITIONS_VIEW_RENDER');
            };

            $scope.ppCreditTermsUrl = 'https://' + _squid.$meta.cdnHost + '/webstatic/checkout/hermes/html/PayPalCreditTerms_print.html';
            $scope.ppCreditTermsUrl_v2 = 'https://' + _squid.$meta.cdnHost + '/webstatic/checkout/hermes/html/PayPalCreditTerms_v2.html';

            $scope.handleAgreeToTermsClick = function () {
                this.showConfirmationModal();
                _logger.$logger.info('bmlAgreeToTerms', {});
            };

            $scope.showConfirmationModal = function (show) {
                show = angular.isUndefined(show) ? true : show;
                $scope.bmlFlags.showConfirmationModal = show;
            };

            $scope.agreeToTermsConfirmation = function (event) {
                event.preventDefault();

                _logger.$logger.info('bmlConfirmAgreeToTermsPopup', {});
                this.showConfirmationModal(false);
                this.onContinue();
            };

            $scope.cancelApplication = function (event) {
                event.preventDefault();
                _logger.$logger.info('bmlCancelApplication', {});
                $scope.bmlStateHandler.payInFullRedirect();
            };

            // when the esc key is pressed
            $('html').on('keyup', function (ev) {
                if (ev.which === 27) {
                    $scope.showConfirmationModal(false);
                }
            });

            $scope.onContinue = function () {
                _logger.$logger.info('BMLTERMSNCONDITIONS_VIEW_SUBMIT');
                $scope.bmlStateHandler.applyBML();
            };

            $scope.init();
        }]
    };
});

_angular.$rootScope;

_squid.$populate;

_squid.$meta;

_logger.$logger;

_index.$DeviceInfo;

_auth.$AuthModel;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutPayeeModel;

_index2.$CheckoutSessionModel;

_fi.$BillingAddressesModel;

_user.$PatchPhoneModel;

_directive.$BMLStateHandler;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js
// module id = ../node_modules/xo-credit-components/src/bml-display/xo-bml-terms-and-conditions/directive.js
// module chunks = 0